import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import './styles/global.scss';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <AdminAuthProvider>
            <div className="App">
              <AppRoutes />
            </div>
          </AdminAuthProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
